// DS: MO 7.2 PCP Right Rail Promotion
import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard from '../../../../ShopCard/DeviationShopCard';
const PremiumDownloadPromo = ({ deviations = [], width, overrideHref })=>{
    const { t } = useTranslation();
    const deviation = deviations.find(Boolean);
    if (!deviation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        deviation: deviation,
        width: width,
        withStats: true,
        withPremiumDownloadCount: true,
        overrideHref: overrideHref,
        footerSlot: /*#__PURE__*/ React.createElement(BuyButton, {
            icon: DownloadIcon,
            size: "medium",
            rounded: true,
            fillContainerWidth: true,
            isFakeButton: true
        }, t('sidebar.premiumDownloadPromo.cta'))
    });
};
PremiumDownloadPromo.displayName = 'PremiumDownloadPromo';
export default PremiumDownloadPromo;
